import React from 'react'
import css from '../styles.scss'
import globalCss from '../../../../scss/global.scss'

const Row = ({ id, name, createdAt, isRead, isWrite, delete: _delete, regenerate }) => {
  return (
    <div className={css.tableRow}>
      <div>{name}</div>
      <div><button onClick={(event) => { regenerate(id) }} className={css.btn}>Issue</button></div>
      <div>{createdAt}</div>
      <div><i className={globalCss.iconOk} style={{ display: isRead ? 'inline-block' : 'none' }} /></div>
      <div><i className={globalCss.iconOk} style={{ display: isWrite ? 'inline-block' : 'none' }} /></div>
      <div><button onClick={() => _delete(id)} className={css.btnDelete}>Delete</button></div>
    </div>
  )
}

export default Row



// WEBPACK FOOTER //
// /app/js/components/AccessTokens/Row/index.js